import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.ash,
  errorColor: colors.warningRed
};
export default book;